import { getExemptionNames } from "../../Utils/utils";
import "./Result.css";
import React, { useState } from "react";

function Result(props) {
  const categories = getExemptionNames(props?.allCategories || [], props?.showCompanyOverviewTemplate || false) || [];

const [formData, setFormData]  = useState({
  fullName: '',
  companyName: '',
  emailAddress: '',
  phoneNumber: ''
});

const [formErrors, setFormErrors] = useState({})

  return (
    <>
      <div className="result-content">
        <div className="result-header-title">
          <span>Thank you! Review your Results</span>
        </div>

        {props?.showDynamicText && (
          <div
            className={`result-dynamic-card ${
              categories.length > 0 ? "green" : "orange"
            }`}
          >
            {categories.length > 0 && (
              <>
                <div className="result-exemptions-count-container">
                  <span>Total Number of Potential Exemptions: {categories.length}</span>
                </div>
                <div className="result-exemptions-sub-text">
                  <p>{`The following ${categories.length} exemption${
                    categories.length > 1 ? "s" : ""
                  }  may apply to this entity:`}</p>
                  <ul>
                    {categories.map((c) => {
                      return <li>{`${c.categoryTitle}`}</li>;
                    })}
                  </ul>
                  <p>
                    You have completed the <strong>CTA</strong><em>Comply</em><sup>TM</sup> 
                    Eligibility Wizard for this entity.
                    Based on the selections, it appears at this time that this
                    entity may be exempt from the beneficial ownership reporting
                    requirements of the CTA, the ultimate determination to be
                    made by your counsel.
                  </p>
                </div>
              </>
            )}

            {categories.length === 0 && (
              <>
                <div className="result-exemptions-count-container">
                  <span>Total Number of Potential Exemptions: {categories.length}</span>
                </div>
                <div className="result-exemptions-sub-text result-zero-exemptions-sub-text">
                  You have completed the <strong>CTA</strong><em>Comply</em><sup>TM</sup> Eligibility 
                  for this entity.
                  Based on the selections, it appears that no exemptions apply
                  to this entity; therefore, you may be subject to the CTA’s
                  reporting requirements. The ultimate determination of reporting 
                  requirements should be made by your legal counsel.   
                </div>
              </>
            )}
          </div>
        )}

        <div className="contact-me-form-container">

                <div className="result-content-row contact-us-header">
                Thinking About Filing? Contact Us!
                </div>

          <div className="result-content-row">
            <div className="result-column  full-contact-name-container">
              <div>
                <span>Full Contact Name</span>
              </div>
              <div>
                <input
                  type="text"
                  name={`fullName`}
                  placeholder={`John Doe`}
                  onChange={handleChange} value={formData.fullName}
                />
                {formErrors.fullName && <p className="error-label">{formErrors.fullName}</p>}
              </div>
            </div>

            <div className="result-column  company-name-container">
              <div>
                <span>Company Name</span>
              </div>
              <div>
                <input type="text" name={`companyName`} placeholder={`XYZ Corporation`} 
                onChange={handleChange} value={formData.companyName} />

                {formErrors.companyName && <p className="error-label">{formErrors.companyName}</p>}
              </div>
            </div>
          </div>

          <div className="result-content-row">
            <div className="result-column email-address-container">
              <div>
                <span>Email Address</span>
              </div>
              <div>
                <input
                  type="email"
                  name={`emailAddress`}
                  placeholder={`sample.email@example.com`}
                  onChange={handleChange} value={formData.emailAddress}
                />
                {formErrors.emailAddress && <p className="error-label">{formErrors.emailAddress}</p>}
              </div>
            </div>

            <div className="result-column phone-number-container">
              <div>
                <span>Phone Number</span>
              </div>
              <div>
                <input
                  type="text"
                  name={`phoneNumber`}
                  placeholder={`(000) 000 0000`}
                  onChange={handleChange} value={formData.phoneNumber}
                />
                {formErrors.phoneNumber && <p className="error-label">{formErrors.phoneNumber}</p>}
              </div>
            </div>
          </div>

          <div className="result-content-row">
            <div className="result-contant-me-container">
              <button className="result-contant-me-button" onClick={handleSubmit}>Submit</button>
            </div>
          </div>
        </div>

        <div className="disclaimer-container">
          <p>
            <span className="red-star">*</span>This <strong>CTA</strong><em>Comply</em><sup>TM</sup> Eligibility Wizard 
            (the “Software”) has been designed to provide assistance to users in
            navigating the various exemptions available under the Corporate
            Transparency Act (“CTA”). By using the Software, you acknowledge and
            agree to the terms of the following disclaimer:
          </p>
          <p>
            <b>Informational Purpose Only</b>: The information contained in the
            Software, including, but not limited to, exemption suggestions,
            explanations, and any related content, is provided solely for
            informational purposes. It is not intended to constitute legal
            advice or to substitute for professional legal counsel. The Software
            is not a substitute for seeking qualified legal advice tailored to
            your unique situation.
          </p>
          <p>
            <b>No Attorney-Client Relationship:</b> Use of the Software does not
            create an attorney-client relationship between you and RASi, nor
            does it create any obligation on RASi’s part to provide legal
            representation or guidance in any legal matter.
          </p>

          <p>
            <b>User Responsibility:</b> Users of the Software are responsible
            for verifying the accuracy and relevance of the information provided
            by the Software in their specific context. Users should exercise
            their own judgment and seek professional legal advice when making
            decisions based on the information provided by the Software.
          </p>

          <p>
            <b>No Liability:</b> RASi, its affiliates, directors, employees,
            agents, and representatives shall not be liable for any fees, costs,
            damages, losses, or other liabilities arising out of or in
            connection with the use of or reliance on the information contained
            in the Software. This includes, but is not limited to, any errors,
            inaccuracies, omissions, or misunderstandings related to the CTA,
            exemptions, or legal concepts.
          </p>

          <p>
            <b>Changes to Laws and Regulations:</b> While every effort is made
            to provide the most current information, the Software may not always
            be updated in real time to reflect changes of law or regulations.
            Users should ensure they are referencing the most current legal
            information and consult a legal professional to ensure compliance
            with the latest legal requirements.
          </p>
        </div>
      </div>
    </>
  );

  function handleChange(event) {
    setFormData((prev) => ({...prev,[event.target.name]: event.target.value} ))
  }

  function handleSubmit() {
    const errors = validate();

    if(Object.keys(errors).length > 0) return setFormErrors(errors)

      try {
        fetch("https://fincen-backend-prod.azurewebsites.net/api/submit-eligibility", {
     
        // Adding method type
        method: "POST",
        
        // Adding body or contents to send
        body: JSON.stringify({
            FullName: formData.fullName,
            CompanyName: formData.companyName,
            EmailAddress: formData.emailAddress,
            PhoneNumber: formData.phoneNumber
        }),
        
        // Adding headers to the request
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
        }).then(response => {
          console.log(response.json());
          window.location.href = 'https://www.rasi.com/corporate-transparency/ctacomply.asp';
        });
        console.log({formData});
        
      } catch (error) {
        console.log(error);
      }
  }

  function validate(){
    setFormErrors({})
    const errors = {};
    
    if(!formData.fullName) errors.fullName = 'Your full name is required';
    if(!formData.companyName) errors.companyName = 'The company name is required';
    if(!formData.emailAddress) errors.emailAddress = 'The email is required';
    if(!formData.phoneNumber) errors.phoneNumber = 'The phone number is required';

    return errors;
  }
}

export default Result;
